import pallet from 'constants/colors';

export default {
  container: {
    width: 'calc(100% - 72px)',
    height: 'calc(100% - 26px)',
    paddingLeft: 36,
    paddingRight: 36,
    paddingTop: 18,
    paddingBottom: 8,
    display: 'flex',
    flexDirection: 'column',
  },
  tag: {
    fontSize: 14,
    color: 'white',
    borderRadius: 4,
    padding: 6,
    marginRight: 6,
    backgroundColor: pallet.successColor,
  },
  course: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 12,
    paddingBottom: 6,
  },
  secondary: {
    display: 'flex',
    alignItems: 'center',
    height: 40,
    justifyContent: 'space-between',
  },
  action: {
    flex: '1 1 0',
    justifyContent: 'center',
    minHeight: 40,
    maxHeight: 40,
  },
  actionButton: {
    maxWidth: 'none',
    fontSize: 14,
  },
};



// WEBPACK FOOTER //
// ./src/containers/tiles/styles/TEvents.js